import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { routeConfigs } from './common/constants/route.config';
import { VisitorComponent } from './modules/shared/components/visitor/visitor.component';
import { AiBuddyPlaceListingComponent } from './modules/place-calendar/components/ai.buddy.place.listing/ai.buddy.place.listing.component';
import { LoginComponent } from './common/components/login/login.component';
import { EventAggregatorAdminGuard } from './common/guards/auth.guard';
import { VisitorCalendarComponent } from './modules/shared/components/visitor/visitor.calendar/visitor.calendar.component';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: 'developer/ssr-api',
    title: 'SSR API Integration Guide | ITI Digital DXP',
    loadComponent: () =>
      import('./modules/developer-docs/ssr-api-docs.component').then(
        (m) => m.SsrApiDocsComponent
      ),
  },
  {
    path: 'admin/event-aggregator',
    canActivate: [EventAggregatorAdminGuard],
    loadComponent: () =>
      import('./modules/event-aggregator/event-aggregator.component').then(
        (m) => m.EventAggregatorComponent
      ),
  },
  /** for non lazy loading */
  // {
  //   path: routeConfigs.visitor.path,
  //   component: VisitorComponent,
  //   children: [
  //     {
  //       path: routeConfigs.visitor.eventCalendar.path,
  //       component: VisitorCalendarComponent,
  //     },
  //     {
  //       path: routeConfigs.visitor.eventCalendar.eventMap.path,
  //       component: VisitorEventMapComponent,
  //     },
  //     {
  //       path: routeConfigs.visitor.eventCalendar.createEvent.path,
  //       component: CreateEventComponent,
  //     },
  //     {
  //       path: routeConfigs.visitor.eventDetailsModal.path,
  //       component: VisitorCalendarComponent,
  //     },

  //     {
  //       path: routeConfigs.visitor.placeCalendar.path,
  //       component: VisitorCalendarComponent,
  //     },
  //   ],
  // },

  /** for lazying loading */
  {
    path: routeConfigs.visitor.path,
    component: VisitorComponent,
    children: [
      {
        path: routeConfigs.visitor.eventCalendar.path,
        loadChildren: () => {
          try {
            return import('./modules/event-calendar/event-calendar.module').then(
              (m) => m.EventCalendarModule
            );
          } catch (error) {
            return null;
          }
        },
      },
      {
        path: routeConfigs.visitor.placeCalendar.path,
        loadChildren: () =>
          import('./modules/place-calendar/place-calendar.module').then(
            (m) => m.PlaceCalendarModule
          ),
      },
      {
        path: routeConfigs.visitor.ai.path,
        loadChildren: () =>
          import('./modules/place-calendar/place-calendar.module').then(
            (m) => m.PlaceCalendarModule
          ),
      },
      // {
      //   path: routeConfigs.visitor.ai.path,
      //   children: [
      //     {
      //       path: routeConfigs.visitor.ai.travelBuddy.path,
      //       component: AiBuddyPlaceListingComponent,
      //     },
      //   ],
      // },
      {
        path: routeConfigs.visitor.jobBoard.path,
        loadChildren: () =>
          import('./modules/job-board/job-board.module').then((m) => m.JobBoardModule),
      },

      /** for compatible with V2 routes */
      {
        path: routeConfigs.visitor.favCustomPlace.path,
        redirectTo:
          routeConfigs.visitor.placeCalendar.path +
          '/' +
          routeConfigs.visitor.placeCalendar.favCustomPlace.path,
      },
      {
        path: routeConfigs.visitor.defaultPlace.path,
        redirectTo:
          routeConfigs.visitor.placeCalendar.path +
          '/' +
          routeConfigs.visitor.placeCalendar.category.path,
      },
      {
        path: routeConfigs.visitor.customDefaultPlace.path,
        redirectTo:
          routeConfigs.visitor.placeCalendar.path +
          '/' +
          routeConfigs.visitor.placeCalendar.customDefaultPlace.path,
      },
      {
        path: routeConfigs.visitor.placeMapFavCustomV2.path,
        redirectTo:
          routeConfigs.visitor.placeCalendar.path +
          '/' +
          routeConfigs.visitor.placeCalendar.placeMap.path,
      },
    ],
  },
  {
    path: routeConfigs.tripPlanner.path,
    loadChildren: () =>
      import('./modules/trip-planner/trip-planner.module').then((m) => m.TripPlannerModule),
  },
  // {
  //   path: '',
  //   redirectTo: routeConfigs.auth.login.path,
  //   pathMatch: 'full',
  // },
  {
    path: routeConfigs.auth.login.path,
    component: LoginComponent,
  },
  {
    path: routeConfigs.dashboard.path,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  // {
  //   path: routeConfigs.jobBoard.path,
  //   loadChildren: () =>
  //     import('./modules/job-board/job-board.module').then((m) => m.JobBoardModule),
  // },
];

/** so that child component can get parent component's params */
export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'disabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
  // providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
})
export class AppRoutingModule {}
